$("#chapters-list").on("click", function () {
  $("#chapters-list ul").toggle();
});
$("#prev-reports").on("click", function () {
  $("#prev-reports ul").toggle();
});
